import { render, staticRenderFns } from "./w-calculate-savings.vue?vue&type=template&id=7db173f4"
import script from "./w-calculate-savings.vue?vue&type=script&lang=js"
export * from "./w-calculate-savings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports